module.exports = __webpack_public_path__ + "img/ryjks7.e735159a.png";